import { Action, configureStore } from '@reduxjs/toolkit';
import { createMigrate, persistReducer, persistStore } from 'redux-persist';
import { ThunkAction } from 'redux-thunk';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { useDispatch } from 'react-redux';
import rootReducer, { RootState } from './root-reducer';

import { authSaveSubsetBlacklistFilter } from './modules/auth';
import { middleware } from './middleware';
import migrations from './redux-persist.migrations';
import { sellingCompaniesBlacklistFilter } from './modules/selling-companies';

const development = process.env.NODE_ENV === 'development';

export const persistConfig = {
  key: 'root',
  version: 4,
  storage,
  whitelist: ['auth', 'sellingCompanies'],
  transforms: [authSaveSubsetBlacklistFilter, sellingCompaniesBlacklistFilter],
  debug: development,
  migrate: createMigrate(migrations, { debug: development }),
};

// store configuration
const configureAppStore = (preloadedState?: Partial<RootState>) => {
  const persistedReducer = persistReducer(persistConfig, rootReducer);
  return configureStore({
    reducer: persistedReducer,
    middleware,
    ...(preloadedState && { preloadedState }),
  });
};

// store
const store = configureAppStore();
// persistor
const persistor = persistStore(store);

export default store;
export { store, persistor, configureAppStore, rootReducer };

export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
